import { db } from "../firebase";

export const loadPortfolio = () => async (dispatch) => {
  try {
    dispatch({
      type: "LOAD_PORTFOLIO_REQUEST",
    });
    const portfolio = await db.collection("about_descrption").get();
    dispatch({
      type: "LOAD_PORTFOLIO",
      payload: portfolio.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      }),
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "ERROR",
      payload: error.message,
    });
  }
};
